export interface UnderMaintenanceConfig {
  is_enabled: boolean;
  title?: string | null;
  description?: string | null;
  image_url?: string | null;
}

export interface UIConfig {
  under_maintenance: UnderMaintenanceConfig;
}

export const DEFAULT_UI_CONFIG: UIConfig = {
  under_maintenance: {
    is_enabled: false,
    title: null,
    description: null,
    image_url: null,
  },
};
